// deprecate after all GCNs are on latest after deploy ~2021-10-22
enum DeprecatedRecommendationSource {
  OrderHistory = 0,
  Prediction = 1,
  FavoriteItem = 2,
}

export { DeprecatedRecommendationSource };
